import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from '../common/widget/valueBox'
import Row from '../common/layout/row'
import InfoBox from '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemUser from '../assets/images/user.jpg';
import {
	getLista
} from './dashboardEstoqueFisicoActions';

import contentCardBody from '../common/template/contentCardBody';
import produto from '../produto/produto';

class DashboardEstoqueFisico extends Component {

	state = {
		pesquisar: ''
	}

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.getLista();

		this.idInterval = setInterval(() => {
			this.props.getLista();
		}, 60000);
	}

	componentWillUnmount() {
		clearInterval(this.idInterval);
	}

	render() {

		const listaUnidade = [{ id: 1, nome: 'ÁGUA BOA' }, { id: 3, nome: 'BARRA DO GARÇAS' }, { id: 9, nome: 'PORTO ALEGRE DO NORTE' }, { id: 60, nome: 'RIO VERDE (SERTÃO)' }];
		const listaProduto = [{ id: 1, nome: 'S10', cor: '#FFF8B0' }, { id: 3, nome: 'S500', cor: '#FF4C4C' }];

		return (
			<Content>
				{listaUnidade.map(unidade => (
					<div key={unidade.id} style={{ marginBottom: 30 }}>

						{/* HEADER UNIDADE */}
						<div style={{
							textAlign: 'center',
							fontSize: 18,
							fontWeight: 'bold',
							marginBottom: 15,
							padding: 10,
							background: '#1F3066',
							color: '#fff',
							borderRadius: 8
						}}>
							{unidade.nome}
						</div>

						<Row alignCenter>
							{listaProduto.map(produto => {
								let quantidade = 0;
								let capacidade = 0;

								const lista = this.props.lista.filter(
									item => item.id_unidade == unidade.id && item.id_produto == produto.id
								);

								lista.forEach(item => {
									quantidade += parseFloat(item.quantidade);
									capacidade += parseFloat(item.capacidade);
								});

								const percentual = parseInt(capacidade > 0 ? (quantidade * 100) / capacidade : 0);
								const percentualFinal = percentual > 100 ? 100 : percentual || 0;

								return (
									<Grid key={produto.id} cols='12 6 6 4'>
										<div style={{
											background: 'linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%)',
											borderRadius: 16,
											boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
											padding: 14,
											height: '100%',
											border: '1px solid #eef1f4'
										}}>

											{(() => {
												const corPrincipal = this.getCorNivel(percentualFinal);

												return (
													<>
														{/* HEADER */}
														<div style={{
															display: 'flex',
															justifyContent: 'space-between',
															alignItems: 'center',
															marginBottom: 10
														}}>
															<div style={{
																fontSize: 14,
																fontWeight: 600,
																color: '#333'
															}}>
																{produto.nome}
															</div>

															<div style={{
																fontSize: 14,
																fontWeight: 700,
																color: corPrincipal
															}}>
																{FormatUtils.formatarValorTelaDecimal(quantidade, 0)} L
															</div>
														</div>

														{/* PROGRESS PRINCIPAL */}
														<div style={{
															background: '#e9edf2',
															borderRadius: 30,
															height: 24,
															position: 'relative',
															marginBottom: 12,
															overflow: 'hidden'
														}}>
															<div style={{
																width: `${percentualFinal}%`,
																background: `linear-gradient(90deg, ${corPrincipal}, ${corPrincipal}cc)`,
																height: '100%',
																borderRadius: 30,
																transition: 'width 0.4s ease'
															}} />

															<span style={{
																position: 'absolute',
																width: '100%',
																textAlign: 'center',
																fontSize: 11,
																fontWeight: 600,
																top: 4,
																color: '#333'
															}}>
																{percentualFinal}%
															</span>
														</div>

														{/* TANQUES */}
														<div style={{
															maxHeight: 150,
															overflowY: 'auto',
															paddingRight: 4
														}}>
															{lista.map(item => {
																const perc = item.percentual > 100 ? 100 : item.percentual || 0;
																const cor = this.getCorNivel(perc);

																return (
																	<div key={item.id} style={{
																		marginBottom: 10,
																		padding: 8,
																		borderRadius: 10,
																		background: '#fff',
																		boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
																	}}>

																		{/* INFO */}
																		<div style={{
																			display: 'flex',
																			justifyContent: 'space-between',
																			fontSize: 11,
																			marginBottom: 4
																		}}>
																			<span style={{ fontWeight: 600 }}>
																				{item.nome_tanque}
																			</span>

																			<span style={{ color: '#777' }}>
																				{DateFormat.formatarDataHoraSqlParaTela(item.datahora_atualizacao)}
																			</span>

																			<span style={{ fontWeight: 600 }}>
																				{FormatUtils.formatarValorTelaDecimal(item.quantidade, 0)} L
																			</span>
																		</div>

																		{/* PROGRESS TANQUE */}
																		<div style={{
																			background: '#e5e7eb',
																			borderRadius: 20,
																			height: 12,
																			position: 'relative',
																			overflow: 'hidden'
																		}}>
																			<div style={{
																				width: `${perc}%`,
																				background: `linear-gradient(90deg, ${cor}, ${cor}aa)`,
																				height: '100%',
																				borderRadius: 20,
																				transition: 'width 0.3s ease'
																			}} />

																			<span style={{
																				position: 'absolute',
																				width: '100%',
																				textAlign: 'center',
																				fontSize: 9,
																				top: -1,
																				color: '#222',
																				fontWeight: 600
																			}}>
																				{perc}%
																			</span>
																		</div>

																	</div>
																);
															})}
														</div>
													</>
												);
											})()}

										</div>
									</Grid>
								);
							})}
						</Row>
					</div>
				))}
			</Content>
		)
	}

	getCorNivel(percentual) {
		if (percentual < 20) return '#e74c3c';   // vermelho
		if (percentual <= 50) return '#f1c40f';  // amarelo
		return '#27ae60';
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dashboardEstoqueFisico.aguardando,
	lista: state.dashboardEstoqueFisico.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DashboardEstoqueFisico)
